import { Drawer as MuiDrawer, DrawerProps } from '@mui/material';

export const Drawer = ({ ...otherProps }: DrawerProps) => {
  return <MuiDrawer {...otherProps} />;
};
